export enum ThemeMode {
  LIGHT = 'LIGHT',
  DARK = 'DARK',
}